import { STORAGE_KEYS } from '../../shared/constants';

const ENCRYPTION_KEY = 'eFleetTerminal2024';

const encryptData = (data: string): string => {
    let encrypted = '';
    for (let i = 0; i < data.length; i++) {
        const charCode = data.charCodeAt(i) ^ ENCRYPTION_KEY.charCodeAt(i % ENCRYPTION_KEY.length);
        encrypted += String.fromCharCode(charCode);
    }
    return btoa(encrypted);
};

const decryptData = (encryptedData: string): string => {
    try {
        const decoded = atob(encryptedData);
        let decrypted = '';
        for (let i = 0; i < decoded.length; i++) {
            const charCode = decoded.charCodeAt(i) ^ ENCRYPTION_KEY.charCodeAt(i % ENCRYPTION_KEY.length);
            decrypted += String.fromCharCode(charCode);
        }
        return decrypted;
    } catch (error) {
        console.error('Error decrypting data:', error);
        return '';
    }
};

export class EncryptedStorage {
    static async setItem(key: string, value: string): Promise<void> {
        try {
            const encrypted = encryptData(value);
            localStorage.setItem(key, encrypted);
        } catch (error) {
            console.error(`Error setting encrypted item ${key}:`, error);
            throw error;
        }
    }

    static async getItem(key: string): Promise<string | null> {
        try {
            const encrypted = localStorage.getItem(key);
            if (!encrypted) return null;
            return decryptData(encrypted);
        } catch (error) {
            console.error(`Error getting encrypted item ${key}:`, error);
            return null;
        }
    }

    static async removeItem(key: string): Promise<void> {
        try {
            localStorage.removeItem(key);
        } catch (error) {
            console.error(`Error removing item ${key}:`, error);
            throw error;
        }
    }

    static async clear(): Promise<void> {
        try {
            Object.values(STORAGE_KEYS).forEach(key => {
                localStorage.removeItem(key);
            });
        } catch (error) {
            console.error('Error clearing storage:', error);
            throw error;
        }
    }
}

